import React, { useEffect, useState, useRef, useCallback } from 'react';
import './Dropdown.scss';
import DropdownOption from './DropdownOption';
import Icons from 'components/Icons';

export interface DropdownInputProps {
  label: string;
  value?: string;
  fullValue?: any;
  style?: any;
  onChange: Function;
  options: any[];
  objectKey: string;
  search?: boolean;
  disabled?: boolean;
  required?: boolean;
  clearValue?: boolean;
  showClear?: boolean;
}

const DropdownInput = ({
  label,
  value = '',
  style = {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  options,
  objectKey,
  search = false,
  disabled = false,
  required = true,
  clearValue = false,
  showClear = true
}: DropdownInputProps) => {
  const ref = useRef(null as any);
  const [isSelected, setSelected] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState(options);
  const [data, setData] = useState(value);

  const hideDropdown = useCallback(() => {
    setSelected(false);
  }, []);

  const select = (selection: any) => {
    setSelected(false);
    onChange(selection);
    setData(selection[objectKey]);
    hideDropdown();
  };

  const clear = () => {
    const blankObject = {} as any;
    blankObject[objectKey] = '';
    onChange(blankObject);
    setData('');
    setDropdownOptions(options);
    setTimeout(() => {
      setSelected(false);
    }, 0);
  };

  const filter = (e: any) => {
    setDropdownOptions(
      options.filter(option =>
        option[objectKey].toLowerCase().includes(e.toLowerCase())
      )
    );
  };
  useEffect(() => {
    // onChange(data)
    setData(value);
    if (clearValue) {
      clear();
    }
  }, [value]);

  useEffect(() => {
    if (JSON.stringify(dropdownOptions) !== JSON.stringify(options)) {
      setDropdownOptions(options);
    }
  }, [options]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        hideDropdown();
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  }, [hideDropdown]);

  return (
    <div
      ref={ref}
      className="dropdowngroup"
      style={style}
      onClick={() => setSelected(true)}
    >
      <input
        autoComplete={'off'}
        style={{ visibility: isSelected && !search ? 'hidden' : 'visible' }}
        value={data}
        className="dropdown-text-input"
        type={'text'}
        required={required}
        onChange={e => {
          setData(e.target.value);
          filter(e.target.value);
        }}
        disabled={disabled}
      />
      {!!data && !disabled && showClear && (
        <div className="dropdown-clear">
          <Icons.CloseIcon
            width="24px"
            onClick={clear}
            className="dropdown-clear-icon"
          />
        </div>
      )}
      <span className="dropdownHighlight"></span>
      <span className="dropdownBar"></span>
      <label
        className="dropdown-text-input-label"
        style={{
          visibility:
            isSelected && !!data && data.length === 0 ? 'hidden' : 'visible'
        }}
      >
        {label}
      </label>
      {!!isSelected && (
        <div
          className="dropdown-options"
          style={{
            height: 'auto',
            maxHeight: isSelected ? '50vh' : 0,
            top: search ? '50px' : '0px'
          }}
        >
          {dropdownOptions.map((option, i) => {
            return (
              <DropdownOption
                option={option}
                objectKey={objectKey}
                onSelect={select}
                key={`${option[objectKey]}${i}`}
              />
            );
          })}
        </div>
      )}
      {/* {error && <div className='error'>{error}</div>} */}
    </div>
  );
};

export default DropdownInput;
